/**
 * Notes + campaigns using this flow (Voluum-style read-mostly list), read from
 * the drawer tracker (Voluum or Tres Commas).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import type { VoluumFlowUpdate } from '@trafficpulse/shared';

import { useFlowTrackerName } from '@/features/flow-optimizer/tracker';

import LinkedCampaigns from './linked-campaigns/LinkedCampaigns';

export interface FlowNotesCampaignsProps {
  flowId: string;
  draft: VoluumFlowUpdate;
  onPatch: (mutator: (d: VoluumFlowUpdate) => void) => void;
}

const FlowNotesCampaigns: FC<FlowNotesCampaignsProps> = ({
  flowId,
  draft,
  onPatch,
}) => {
  const trackerName = useFlowTrackerName();
  return (
    <>
      <details className="rounded-md border border-border/70 bg-muted/10">
        <summary className="cursor-pointer px-2.5 py-1.5 text-xs font-semibold text-foreground">
          Notes
        </summary>
        <div className="border-t border-border/60 p-2">
          <label className="block text-[11px] text-muted-foreground" htmlFor="flow-note">
            Internal note stored on this flow in {trackerName}
          </label>
          <textarea
            id="flow-note"
            value={draft.note?.content ?? ''}
            onChange={(e) =>
              onPatch((d) => {
                d.note = { ...d.note, content: e.target.value };
              })
            }
            rows={3}
            className="mt-1 w-full resize-y rounded-md border border-input bg-background px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring"
            aria-label="Flow notes"
          />
        </div>
      </details>
      <LinkedCampaigns flowId={flowId} />
    </>
  );
};

export default FlowNotesCampaigns;
